import i18n from 'modules/core/lib/i18n'

const useWeekdaysName = () => {
  const weekDaysName: { [key: string]: string } = {
    monday: i18n.t('common.monday').toLowerCase(),
    tuesday: i18n.t('common.tuesday').toLowerCase(),
    wednesday: i18n.t('common.wednesday').toLowerCase(),
    thursday: i18n.t('common.thursday').toLowerCase(),
    friday: i18n.t('common.friday').toLowerCase(),
    saturday: i18n.t('common.saturday').toLowerCase(),
    sunday: i18n.t('common.sunday').toLowerCase(),
  }

  const shortWeekDaysName: { [key: string]: string } = {
    monday: i18n.t('formatter.monday').toLowerCase(),
    tuesday: i18n.t('formatter.tuesday').toLowerCase(),
    wednesday: i18n.t('formatter.wednesday').toLowerCase(),
    thursday: i18n.t('formatter.thursday').toLowerCase(),
    friday: i18n.t('formatter.friday').toLowerCase(),
    saturday: i18n.t('formatter.saturday').toLowerCase(),
    sunday: i18n.t('formatter.sunday').toLowerCase(),
  }

  return {
    weekDaysName,
    shortWeekDaysName,
  }
}

export default useWeekdaysName
